"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7390],{

/***/ 7390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ endpoints_namespaceObject; }
});

// NAMESPACE OBJECT: ./services/http/wap/page/endpoints.ts
var endpoints_namespaceObject = {};
__webpack_require__.r(endpoints_namespaceObject);
__webpack_require__.d(endpoints_namespaceObject, {
  "findPath": function() { return findPath; },
  "get": function() { return get; },
  "globalSearch": function() { return globalSearch; },
  "preview": function() { return preview; }
});

// EXTERNAL MODULE: ./services/http/wap/http.ts
var http = __webpack_require__(889);
// EXTERNAL MODULE: ./node_modules/dot-prop/index.js
var dot_prop = __webpack_require__(6833);
;// CONCATENATED MODULE: ./services/http/wap/page/enums.ts
var EntityFieldType;
(function(EntityFieldType) {
    EntityFieldType[EntityFieldType["Boolean"] = 0] = "Boolean";
    EntityFieldType[EntityFieldType["Color"] = 1] = "Color";
    EntityFieldType[EntityFieldType["Date"] = 2] = "Date";
    EntityFieldType[EntityFieldType["Editor"] = 3] = "Editor";
    EntityFieldType[EntityFieldType["File"] = 4] = "File";
    EntityFieldType[EntityFieldType["Image"] = 5] = "Image";
    EntityFieldType[EntityFieldType["Link"] = 6] = "Link";
    EntityFieldType[EntityFieldType["LongText"] = 7] = "LongText";
    EntityFieldType[EntityFieldType["Number"] = 8] = "Number";
    EntityFieldType[EntityFieldType["Picture"] = 9] = "Picture";
    EntityFieldType[EntityFieldType["Price"] = 10] = "Price";
    EntityFieldType[EntityFieldType["Reference"] = 11] = "Reference";
    EntityFieldType[EntityFieldType["Text"] = 12] = "Text";
    EntityFieldType[EntityFieldType["Video"] = 13] = "Video";
})(EntityFieldType || (EntityFieldType = {}));

// EXTERNAL MODULE: ./services/http/wap/query/mappers.ts
var mappers = __webpack_require__(9278);
;// CONCATENATED MODULE: ./services/http/wap/mappers.ts



var getReferenceValue = function(param, refs) {
    var type = param.type, ref = param.ref, _mappings = param.mappings, mappings = _mappings === void 0 ? [] : _mappings;
    if (ref) {
        if (type === 'link') {
            var link = refs.links[ref];
            if (link) {
                return link.href;
            }
        } else if (type === 'navigation') {
            var menu = refs.navigations[ref];
            if (menu) {
                return menu;
            }
        } else if (type === 'query') {
            var query = refs.queries[ref];
            if (query) {
                return (0,mappers/* mapQuery */.w)(query, mappings);
            }
        } else if (type === 'string') {
            var string = refs.strings[ref];
            if (string) {
                return string;
            }
        } else if (type === 'page') {
            var field = refs.page[ref];
            if (field) {
                return field;
            }
        } else if (type === 'field') {
            var field1 = refs.fields[ref];
            if (field1) {
                if (Array.isArray(field1)) {
                    return mapPageFieldsByMappings(field1, mappings);
                }
                return field1;
            }
        } else {
            var file = refs.files[ref];
            if (file) {
                return file.path;
            }
        }
    }
    return null;
};
var getReference = function(tree, refs) {
    if (tree) {
        if ('type' in tree && 'ref' in tree) {
            tree = getReferenceValue(tree, refs);
        } else {
            for(var key in tree){
                var branch = tree[key];
                if (branch) {
                    if (Array.isArray(branch)) {
                        tree[key] = branch.map(function(leaf) {
                            return getReference(leaf, refs);
                        });
                    } else if (typeof branch === 'object') {
                        if ('type' in branch) {
                            if (branch.type === 'static') {
                                tree[key] = branch.label;
                            } else {
                                if ('ref' in branch) {
                                    tree[key] = getReferenceValue(branch, refs);
                                }
                            }
                        } else {
                            tree[key] = getReference(branch, refs);
                        }
                    } else {
                        tree[key] = branch;
                    }
                }
            }
        }
    }
    return tree;
};
var getNavigations = function(data) {
    var items = [];
    if (!data.children) return items;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = data.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var ref;
            items.push({
                title: item.title,
                href: ((ref = item.page) === null || ref === void 0 ? void 0 : ref.path) || item.staticUrl,
                icon: item.icon,
                target: item.target,
                className: item.className,
                children: getNavigations(item)
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return items;
};
var getRefsObject = function(data, page) {
    var refs = {
        fields: {},
        files: {},
        navigations: {},
        links: {},
        queries: {},
        strings: {},
        page: {
            image: {},
            path: {},
            title: ''
        }
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var ref = _step.value;
            if (ref.values) {
                if (ref.key === 'files') {
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = ref.values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var file = _step1.value;
                            refs.files[file.id] = {
                                path: file.path,
                                mimetype: file.mimeType,
                                extension: file.extension,
                                size: file.size
                            };
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                } else if (ref.key === 'links') {
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = ref.values[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var link = _step2.value;
                            refs.links[link.id] = {
                                href: link.path,
                                title: link.title
                            };
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                } else if (ref.key === 'navigations') {
                    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                    try {
                        for(var _iterator3 = ref.values[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                            var menu = _step3.value;
                            refs.navigations[menu.id] = getNavigations(menu);
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                _iterator3.return();
                            }
                        } finally{
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                } else if (ref.key === 'strings') {
                    var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
                    try {
                        for(var _iterator4 = ref.values[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                            var string = _step4.value;
                            refs.strings[string.id] = string.title;
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                                _iterator4.return();
                            }
                        } finally{
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }
                } else if (ref.key === 'queries') {
                    var _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined;
                    try {
                        for(var _iterator5 = ref.values[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true){
                            var query = _step5.value;
                            refs.queries[query.id] = query.values.data;
                        }
                    } catch (err) {
                        _didIteratorError5 = true;
                        _iteratorError5 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                                _iterator5.return();
                            }
                        } finally{
                            if (_didIteratorError5) {
                                throw _iteratorError5;
                            }
                        }
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (page) {
        refs.page = {
            title: page.title,
            path: {
                href: page.path,
                children: page.title
            },
            image: page.image
        };
        refs.fields = page.fields || {};
    }
    return refs;
};
var getEntityRefsObject = function(type, data) {
    if (type === EntityFieldType.Link) {
        return getRefsObject([
            {
                key: 'links',
                values: data
            }
        ]);
    } else {
        return getRefsObject([
            {
                key: 'files',
                values: data
            }
        ]);
    }
};

;// CONCATENATED MODULE: ./services/http/wap/page/mappers.ts


function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var mapPage = function(res) {
    var ref;
    var page = {
        id: res.data.id,
        alternates: res.data.alternates || [],
        language: res.data.languageId,
        layout: [],
        metatags: getReference(_objectSpread({}, res.data.metaTags), getRefsObject(res.data.refs)),
        path: res.data.path,
        theme: res.data.layout.themeId,
        title: res.data.title,
        fields: mapPageFields(((ref = res.data.dynamicEntity) === null || ref === void 0 ? void 0 : ref.columns) || []),
        image: getReference(_objectSpread({}, res.data.image), getRefsObject(res.data.refs)),
        views: getReference(_objectSpread({}, res.data.views), getRefsObject(res.data.refs)),
        refs: getRefsObject(res.data.refs)
    };
    return _objectSpread({}, page, {
        layout: (res.data.layout.schema || []).map(function(component) {
            return getReference(_objectSpread({}, component), getRefsObject(res.data.layout.refs, page));
        })
    });
};
var mapPageFields = function(columns) {
    var fields = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function(_iterator, _step) {
            var column = _step.value;
            if (Array.isArray(column.data)) {
                fields[column.name] = column.data.reduce(function(prev, next) {
                    return _toConsumableArray(prev).concat([
                        next.value
                    ]);
                }, []);
            } else if (typeof column.data.value === 'object') {
                if (Array.isArray(column.data.value)) {
                    fields[column.name] = column.data.map(function(item) {
                        var ref;
                        return getReference(item, getEntityRefsObject(column.type, (ref = column.data) === null || ref === void 0 ? void 0 : ref.refs));
                    });
                } else {
                    var ref1;
                    fields[column.name] = getReference(_objectSpread({}, column.data.value), getEntityRefsObject(column.type, (ref1 = column.data) === null || ref1 === void 0 ? void 0 : ref1.refs));
                }
            } else {
                fields[column.name] = column.data.value;
            }
        };
        for(var _iterator = columns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop(_iterator, _step);
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return fields;
};
var mapPageFieldsByMappings = function(field, mappings) {
    var data = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = field[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var value = {};
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = mappings[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var mapping = _step1.value;
                    var property = (0,dot_prop/* getProperty */.$s)({
                        value: item
                    }, mapping.path);
                    if (property) {
                        value[mapping.name] = property;
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            data.push(value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return data;
};
var mapPagePath = function(res) {
    return res.data;
};

;// CONCATENATED MODULE: ./services/http/wap/page/endpoints.ts


var get = function(environment, params) {
    return (0,http/* request */.W)(environment, {
        method: 'get',
        url: "/pages/path?path=".concat(params.path)
    }, {
        res: mapPage
    });
};
var preview = function(environment, id) {
    return (0,http/* request */.W)(environment, {
        method: 'get',
        url: "/pages/preview/".concat(id)
    }, {
        res: mapPage
    });
};
var findPath = function(environment, params) {
    return (0,http/* request */.W)(environment, {
        method: 'get',
        url: "/pages/".concat(params.language, "/find-path?path=").concat(params.path)
    }, {
        res: mapPagePath
    });
};
var globalSearch = function(environment, params) {
    return (0,http/* request */.W)(environment, {
        method: 'get',
        url: "/pages/".concat(params.language, "/global-search?pageLength=200&search=").concat(params.search)
    });
};

;// CONCATENATED MODULE: ./services/http/wap/page/index.ts




/***/ })

}]);